import { STATEMENT_KEYS, STATEMENTS } from "../statements";
import { useContext } from "react";
import { LocaleContext } from "../components/localization_wrapper";
import { apiClient } from "../client";

export function NextStatement() {
  const i18n = useContext(LocaleContext);
  const answeredStatements = apiClient.treesponses.map((s) =>
    s.getAnswer("statement"),
  );
  const availableStatements = STATEMENT_KEYS.filter(
    (s) => !answeredStatements.includes(s) && STATEMENTS[s].available,
  )
    .map((key) => ({ key, statement: STATEMENTS[key] }))
    .sort((s1, s2) => s1.statement.order - s2.statement.order);

  function navigateWithTurbo(event) {
    if (window.Turbo === undefined) return;

    const href = event.currentTarget?.href || event.target.href;
    if (href) {
      event.preventDefault();
      window.Turbo.visit(href);
    }
  }

  if (availableStatements.length === 0) {
    return (
      <>
        <title>{i18n.t("next_statement.title")}</title>
        <main className="next">
          <div className="next__intro">
            <h1 className="next__title">{i18n.t("next_statement.title")}</h1>
            <p className="next__description">
              {i18n.t("next_statement.description")}
            </p>
          </div>{" "}
          <div className="next__options">
            <a
              href={`/${i18n.locale}`}
              className="next__link next__link--button"
              onClick={navigateWithTurbo}
            >
              {i18n.t("thanks.to_homepage")}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="next__link-icon"
              >
                <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
              </svg>
            </a>
          </div>
        </main>
      </>
    );
  }

  return (
    <>
      <title>{i18n.t("next_statement.title")}</title>
      <main className="next">
        <div className="next__intro">
          <h1 className="next__title">{i18n.t("next_statement.title")}</h1>
          <p className="next__description">
            {i18n.t("next_statement.description")}
          </p>
        </div>
        <div className="next__options">
          {availableStatements.map(({ key, statement }) => (
            <a
              href={`/${i18n.locale}/${statement.bpart_path}`}
              key={key}
              className="next__link next__link--button"
              onClick={navigateWithTurbo}
            >
              {i18n.t(["statements", key, "name"])}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="currentColor"
                className="next__link-icon"
              >
                <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
              </svg>
            </a>
          ))}
        </div>
        <div className="next__link next__link--home">
          <a
            className="next__link"
            href={`/${i18n.locale}`}
            onClick={navigateWithTurbo}
          >
            {i18n.t("next_statement.to_homepage")}{" "}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="currentColor"
              className="next__link-icon"
            >
              <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
            </svg>
          </a>
        </div>
      </main>
    </>
  );
}
